<template>
    <div>

      <z-centralized-toolbar>
        <!-- <v-toolbar-items> -->
          <v-btn depressed rounded color="primary" :to="{name: 'FornecedoresAdicionar'}">
            <v-icon left>person_add</v-icon>Adicionar Fornecedor
          </v-btn>
          <v-btn icon id="btAtualizar" text small @click="refresh" :loading="$store.state.loading">
            <v-icon>refresh</v-icon>
            <v-tooltip bottom activator="#btAtualizar">
              Atualizar
            </v-tooltip>
          </v-btn>
        <!-- </v-toolbar-items> -->

        <!-- <v-spacer></v-spacer> -->
        
        <div style="width: 300px;" class="ml-5">
          <v-text-field
            rounded
            outlined
            single-line
            dense
            autofocus
            clearable
            hide-details
            placeholder="Pesquisar"
            prepend-inner-icon="search"
            v-model="search"
            @keydown.enter="refresh" 
            @click:clear="limparBusca"
          ></v-text-field>
        </div>
      </z-centralized-toolbar>



        <z-container>
          <h3 class="text-body-1 mb-3">Fornecedores</h3>
          <v-card>
            <v-data-table 
              item-key="id"
              sort-by="id"
              sort-desc
              :headers="headers" 
              :items="fornecedores" 
              :loading="false" 
              :search="search"
              :options.sync="options" 
              :server-items-length="total_de_registros" 
              :footer-props="$globals.FOOTER_PROPS"
            >
              <template v-slot:item="{item: fornecedor}">
                <tr>
                  <td>{{ fornecedor.id }}</td>
                  <td>{{ fornecedor.razao }}</td>
                  <td>{{ fornecedor.celular }}</td>
                  <td class="text-center">
                    <v-btn title="Produtos" icon @click="produtosFornecedor(fornecedor)">
                      <v-icon>card_travel</v-icon>
                    </v-btn>
                    <v-btn title="Editar" icon @click="editar(fornecedor)">
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn title="Excluir" icon @click="perguntarExcluir(fornecedor)">
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </z-container>


      <z-dialogo ref="dialogoExcluir" titulo="Deseja excluir esse fornecedor?" :dividers="true" largura="500px">
        <div slot="texto">
          <v-list>

            <v-list-item>
              <!-- <v-list-item-action>
                <v-icon color="indigo">mail</v-icon>
              </v-list-item-action> -->
              <v-list-item-content>
                <v-list-item-subtitle>Razão Social</v-list-item-subtitle>
                <v-list-item-title>{{ fornecedor.razao }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider inset v-show="fornecedor.telefone"></v-divider>

            <v-list-item v-show="fornecedor.celular">
              <!-- <v-list-item-action>
                <v-icon color="indigo">phone</v-icon>
              </v-list-item-action> -->
              <v-list-item-content>
                <v-list-item-subtitle>Telefone</v-list-item-subtitle>
                <v-list-item-title>{{ fornecedor.telefone }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

          </v-list>
        </div>

        <v-btn text @click="$refs.dialogoExcluir.fechar()" :disabled="excluindo">Cancelar</v-btn>
        <v-btn color="primary darken-1" text @click="confirmarExcluir" :loading="excluindo" :disabled="excluindo">Excluir</v-btn>

      </z-dialogo>

      <z-dialogo-sim-nao ref="dialogoRemoverFornecedor" titulo="Remover fornecedor?" botaoSim="Remover" botaoNao="Cancelar" :loading="excluindo">
        O fornecedor <b>{{ fornecedor.razao }}</b> será removido.
      </z-dialogo-sim-nao>
    </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      // globals,
      headers: [
        { text: "Código", value: "id", width: "150px" },
        { text: "Razão Social", value: "razao" },
        { text: "Celular", value: "celular", sortable: false },
        { text: "Opções", value: "", width: "200px", align: "center", sortable: false }
      ],
      excluindo: false,
      fornecedor: {},
    };
  },

  created() {
    this.setTitulo('Cadastro de Fornecedores');
  },

  methods: {
    ...mapMutations(['setTitulo', "LOADING_OFF"]),
    ...mapActions('fornecedores', ['listar', 'excluir', 'abrir']),

    async refresh() {
      try {
        await this.listar();
      } catch (error) {
        this.$eventbus.erro('Não foi possível obter a lista de fornecedores.', error);
        throw error;
      } finally {
        this.LOADING_OFF();
      }
    },

    async editar(fornecedor) {
      await this.abrir(fornecedor.id);
      this.$router.push({ name: "FornecedoresEditar", params: { id: fornecedor.id } });
    },

    perguntarExcluir(fornecedor) {
      this.fornecedor = fornecedor;
      this.$refs.dialogoRemoverFornecedor.abrir()
        .then(async response => {
          if (response == true)
            await this.confirmarExcluir();
        })
    },

    async confirmarExcluir() {
      try {
        this.excluindo = true;
        await this.excluir(this.fornecedor.id);
      } finally {
        this.$refs.dialogoRemoverFornecedor.fechar();
        this.excluindo = false;
        this.$eventbus.notificar('Fornecedor excluído com sucesso!');
      }
    },

    produtosFornecedor(fornecedor) {
      this.$router.push({
        name: 'ProdutosFornecedor', 
        params: { 
          id: fornecedor.id
        }
      });
    },

    limparBusca() {
      this.search = '';
      this.$store.commit('fornecedores/SET_PAGE', 1);
      this.refresh();
    },
  },

  computed: {
    ...mapState("fornecedores", ["fornecedores", 'pagination', 'total_de_registros']),

    search: {
      get () {
        return this.$store.state.fornecedores.search
      },
      set (search) {
        this.$store.commit('fornecedores/SET_SEARCH', search);
      }
    },

    options: {
      get () {
        return this.$store.state.fornecedores.pagination
      },
      set (options) {
        this.$store.commit('fornecedores/UPDATE_PAGINATION', options);
      }
    },
  },

  watch: {
    options: {
      handler() {
        this.refresh();
      },
      deep: true,
    },
  }
};
</script>

<style scoped>
</style>
